export default __webpack_public_path__ + "static/media/team_b_wins.4ef31daa.mp3";